import type { Key, KeyColor, SymbolItem } from '@/types/piclick';
import { KeyAccordion } from './KeyAccordion';

type Props = {
  keys: Key[];
  symbols: SymbolItem[];
  keyColors: KeyColor[];
  openIndex: number | null;
  onOpenChange: (index: number | null) => void;
  onChange: (keys: Key[]) => void;
};

export function KeysSection({
  keys,
  symbols,
  keyColors,
  openIndex,
  onOpenChange,
  onChange,
}: Props) {
  const updateKey = (index: number, patch: Partial<Key>) => {
    const next = keys.map((k, i) => (i === index ? { ...k, ...patch } : k));
    onChange(next);
  };

  if (keys.length === 0) {
    return (
      <p className="rounded-[1rem] border-2 border-dashed border-plum/30 bg-cream/40 p-4 text-center text-sm text-plum/70">
        Escolha um tamanho na etapa 1 pra liberar a configuração das teclas.
      </p>
    );
  }

  return (
    <ol className="space-y-3">
      {keys.map((key, idx) => (
        <KeyAccordion
          key={idx}
          index={idx}
          keyData={key}
          symbols={symbols}
          keyColors={keyColors}
          isOpen={openIndex === idx}
          onToggle={() => onOpenChange(openIndex === idx ? null : idx)}
          onChange={(patch) => updateKey(idx, patch)}
        />
      ))}
    </ol>
  );
}
